import { Button, Space, Spin, Table } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { useEffect, useState } from 'react';
import { EmployeeRes } from '../../../response/employee.response';
import { useEmployee } from '../employee.hook';
import { AddEmployeeComponent } from './add-employee.component';
import { UpdateEmployeeComponent } from './update-employee.component';
import { EmployeeFilterComponent } from './filter.component';
import { formatName } from '../../../util/name-helper';
import { EmployeeService } from '../../../service/employee.service';
import { DownloadAttendanceReportComponent } from './download-attendance-report';


export const MainEmployeeTableComponent = () => {
    const { loading, employeeList, fetchEmployeeList, employeeSearchReq, updateLoading } = useEmployee()
    const [addNewEmployee, setOpenNewEmployee] = useState(false)
    const [updateEmployee, setUpdateEmployee] = useState<EmployeeRes | undefined>(undefined)

    const [downloadAttendanceReport, setDownloadAttendanceReport] = useState<boolean>(false)

    const updateOpenNewEmployee = () => {
        if (addNewEmployee) {
            fetchEmployeeList({ ...employeeSearchReq, pageNumber: 1 }, () => { updateLoading(false) }, () => { updateLoading(false) })
        }
        setOpenNewEmployee(prevVal => !prevVal);
    }

    const cancelEmployeeEdit = () => {
        setUpdateEmployee(prevVal => undefined);
    }

    const cancelDownloadReport = () => {
        setDownloadAttendanceReport(false);
    }

    useEffect(() => {
        fetchEmployeeList({ ...employeeSearchReq, pageNumber: 1 }, () => { updateLoading(false) }, () => { updateLoading(false) })
    }, [])

    const columnList: ColumnsType<EmployeeRes> = [
        {
            title: 'Employee Id',
            dataIndex: 'employeeId',
            key: 'employeeId',
            render: (employeeId) => <span>{`RB${String(employeeId).padStart(3, '0')}`}</span>,
        },
        {
            title: 'Name',
            dataIndex: 'userInfo',
            key: 'name',
            render: (userInfo) => <span>{formatName(userInfo.name)}</span>,
        },
        {
            title: 'Phone',
            dataIndex: 'userInfo',
            key: 'phone',
            render: (userInfo) => <span>+91 {userInfo.phone}</span>,
        },
        {
            title: 'Online',
            dataIndex: 'online',
            key: 'online',
            render: (online) => <>
                {online == 1 ?
                    <span style={{ color: 'green' }}>Online</span> :
                    <span style={{ color: 'red' }}>Offline</span>
                }
            </>,
        },
        {
            title: 'Email',
            dataIndex: 'userInfo',
            key: 'email',
            render: (userInfo) => <span>{userInfo.email}</span>,
        },
        {
            title: 'Permissions',
            key: 'permissionList',
            dataIndex: 'permissionList',
            render: (_, { permissionList }) => (
                <div style={{ maxWidth: 84, maxHeight: 84 }}>
                    <span>{permissionList.length} Permissions</span>
                    {/* {permissionList.map((permission: string, index: number) => {
                        const color = getColorBynumber(index)
                        return (
                            <Tag color={color} key={permission}>
                                {permission.toUpperCase()}
                            </Tag>
                        );
                    })} */}
                </div>
            ),
        },
        {
            title: 'Action',
            dataIndex: 'id',
            key: 'id',
            onCell: (employee, rowIndex) => {
                return {
                    onClick: (ev) => {
                        setUpdateEmployee(employee)
                    },
                };
            },
            render: (id) => <a>Edit</a>,
        },
        {
            title: 'Action',
            dataIndex: 'paused',
            key: 'paused',
            onCell: (employee, rowIndex) => {
                return {
                    onClick: (ev) => {
                        pauseEmployee(employee)
                    },
                };
            },
            render: (paused) => <a>{paused == true ? "Resume" : "Pause"}</a>,
        },
        {
            title: 'Action',
            dataIndex: 'id',
            key: 'id',
            onCell: (employee, rowIndex) => {
                return {
                    onClick: (ev) => {
                        removeEmployee(employee)
                    },
                };
            },
            render: (id) => <a style={{ color: 'red' }}>Remove</a>,
        },
    ];

    const pauseEmployee = async (employeeRes: EmployeeRes) => {
        await EmployeeService.pause(employeeRes.id)
        window.location.reload()
    }

    const removeEmployee = async (employeeRes: EmployeeRes) => {
        await EmployeeService.remove(employeeRes.id)
        window.location.reload()
    }

    return <div style={{ marginTop: -42 }}>
        <Space direction="horizontal" style={{ width: '100%', justifyContent: 'end', marginBottom: 8 }}>
            <EmployeeFilterComponent setDownloadAttendanceReport={setDownloadAttendanceReport}/>
            <Button type="primary" onClick={updateOpenNewEmployee}>Add New</Button>
        </Space>

        <Table

            className='task-main-table task-table'
            columns={columnList} dataSource={employeeList}
            pagination={{ defaultPageSize: 30, showSizeChanger: true, pageSizeOptions: ['20', '50', '100', '200', '300', '400', '500'] }}
            loading={{ indicator: <div><Spin /></div>, spinning: loading }} />

        {addNewEmployee && <>
            <AddEmployeeComponent open={addNewEmployee} onCancel={updateOpenNewEmployee} />
        </>}

        {updateEmployee &&
            <UpdateEmployeeComponent employee={updateEmployee} open={true} onCancel={cancelEmployeeEdit} />
        }

        {downloadAttendanceReport &&
            <DownloadAttendanceReportComponent open={true} onCancel={cancelDownloadReport} />
        }

    </div>
}